import {
  UnflownAirwayImportStatus,
  type UnflownAirwayImportPreview,
  type UnflownAirwayImportPreviewItem,
} from "~/application/types";
import type { UnflownAirwayImportPreviewDTO, UnflownAirwayImportPreviewItemDTO } from "../dtos";

const STATUS_MAP: Record<string, UnflownAirwayImportStatus> = {
  valid: UnflownAirwayImportStatus.VALID,
  not_found: UnflownAirwayImportStatus.NOT_FOUND,
  duplicated: UnflownAirwayImportStatus.DUPLICATED,
  already_exists: UnflownAirwayImportStatus.ALREADY_EXISTS,
};

export const mapUnflownAirwayImportPreviewItem = (
  data: UnflownAirwayImportPreviewItemDTO,
): UnflownAirwayImportPreviewItem => {
  return {
    ticket: data.ticket,
    tracker: data.tracker,
    creditValue: data.credit_value,
    issueDate: data.issue_date ?? data.expired_at,
    expiredAt: data.expired_at,
    passengerUuid: data.passenger_uuid ?? null,
    airwayOrderUuid: data.airway_order_uuid ?? null,
    status: STATUS_MAP[data.status] ?? UnflownAirwayImportStatus.NOT_FOUND,
    message: data.message,
    existing: data.existing
      ? {
          uuid: data.existing.uuid,
          creditValue: data.existing.credit_value,
          expiredAt: data.existing.expired_at,
          status: data.existing.status,
        }
      : null,
  };
};

export const mapUnflownAirwayImportPreview = (
  data: UnflownAirwayImportPreviewDTO,
): UnflownAirwayImportPreview => {
  return {
    data: data.data.map(mapUnflownAirwayImportPreviewItem),
    summary: {
      total: data.summary.total,
      valid: data.summary.valid,
      notFound: data.summary.not_found,
      alreadyExists: data.summary.already_exists,
      duplicated: data.summary.duplicated,
    },
  };
};
